import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { TextInput } from 'react-native-paper';
import { Colors } from '../../themes';
import { DebouncedTextInput } from '../forms';

type CategorySearchInputProps = {
  value: string;
  onChangeText: (text: string) => void;
  placeholder?: string;
};

export const CategorySearchInput: React.FC<CategorySearchInputProps> = ({
  value,
  onChangeText,
  placeholder,
}) => {
  const { t } = useTranslation();

  return (
    <View style={styles.searchContainer}>
      <DebouncedTextInput
        debounceTimeMs={500}
        debounceFunc={() => {}}
        placeholder={placeholder || t('file.filter.searchCategories')}
        value={value}
        onBlur={() => {}}
        onChangeText={onChangeText}
        left={<TextInput.Icon icon="magnify" color={Colors.grayFill} />}
        right={
          value ? (
            <TextInput.Icon
              icon="close"
              size={20}
              color={Colors.black}
              onPress={() => onChangeText('')}
            />
          ) : (
            <View />
          )
        }
        height={44}
        outlineStyle={styles.searchInputStyle}
        disableInnerStyle={true}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  searchContainer: {
    borderBottomWidth: 0,
    marginBottom: 8,
  },
  searchInputStyle: {
    backgroundColor: Colors.white,
    borderWidth: 0,
    paddingHorizontal: 0,
  },
});
